<template>
  This site is protected by reCAPTCHA and the Google
  <a href="https://policies.google.com/privacy">Privacy Policy</a> and
  <a href="https://policies.google.com/terms">Terms of Service</a> apply.
</template>

<script>
export default {
  name: "GoogleRecaptchaDisclaimer"
}
</script>

<style scoped>

</style>